import axios from 'axios';
import authHeader from './auth-header';

class ParticipantDataService {
//   getAll() {
//     return http.get("/competitions");
//   }

//   get(id) {
//     return http.get(`/competitions/${id}`);
//   }

//   create(data) {
//     return http.post("/competitions", data);
//   }

  update(data, user_type) {
    //   return axios.put(`/api/participants/${data.participant_id}`, { headers: authHeader(), data: data});
      if ( user_type == 'mod' ) {
        return axios.put(
            `/api/mod/competition/${data.competition_id}/participant/${data.participant_id}`
            , data, { headers: authHeader() });
      } else {
        return axios.put(
            `/api/competition/${data.competition_id}/participant/${data.participant_id}`, data, { headers: authHeader() });
      }
}

//   delete(id) {
//     return http.delete(`/competitions/${id}`);
//   }

//   deleteAll() {
//     return http.delete(`/competitions`);
//   }

//   findByTitle(title) {
//     return http.get(`/competitions?title=${title}`);
//   }
}

export default new ParticipantDataService();

